import Alpine from 'alpinejs'

Alpine.directive('inview', (element, { expression }, { evaluate, cleanup }) => {
    
    const options = {
        threshold: .2
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if(entry.isIntersecting){
                evaluate(expression);
                observer.unobserve(element);
            }
        })
    }, options); 

    observer.observe(element); 

    cleanup(() => {
        observer.unobserve(element);
    }) 
})
